import React from "react";
import "../styles.css";
import Dashboard from "./Dashboard";
import { useState, useEffect } from "react";
import { useActionData, useLocation, useNavigate } from "react-router-dom";
import UserProfileScreen from "./UserProfileScreen";

// This is where the user ends up after logging in, or clicking "Home" in the navbar.
const UserWelcomeScreen = ({ setSelectedSection }) => {
  const username = localStorage.getItem("username");
  const location = useLocation();
  const navigate = useNavigate();
  const navigateToScreen = (screen) => {
    setSelectedSection(screen);
    navigate("/UserHome");
  };
  return (
    <div className="welcome-container">
      <div className="welcome-title-container">
        <h1>Hi {username}, Welcome Back</h1>
      </div>
      <div className="welcome-title-center">
        <img
          className="welcome-title-home-icon"
          src={require("../images/home_icon.png")}
          alt="logo"
        />
        <h1>HOME</h1>
      </div>
      <div className="welcome-grid-top">
        <div id="messages-button" className="welcome-card">
          <div className="welcome-card-name">
            <h3>Messages</h3>
            <div className="welcome-card-count-resized">
              <p>0</p>
            </div>
          </div>
          <div
            className="welcome-card-body"
            onClick={() => navigateToScreen("Messages")}
          >
            <div className="welcome-card-detail">
              <h4>0 new message</h4>
            </div>
            <div>
              <div className="welcome-card-count">
                <p>0</p>
              </div>
            </div>
          </div>
        </div>
        <div id="schedule-button" className="welcome-card">
          <div className="welcome-card-name">
            <h3>Schedule</h3>
            <img
              className="welcome-card-logo-resized"
              src={require("../images/calendar_icon.png")}
              alt="logo"
            />
          </div>

          <div
            className="welcome-card-body"
            onClick={() => navigateToScreen("Calendar")}
          >
            <div className="welcome-card-detail">
              <h4>Next Appointment</h4>
              <p>No Appointment</p>
            </div>
            <div>
              <img
                className="welcome-card-logo"
                src={require("../images/calendar_icon.png")}
                alt="logo"
              />
            </div>
          </div>
        </div>
        <div
          id="provider-button"
          className="welcome-card"
          onClick={() => navigateToScreen("Provider")}
        >
          <div className="welcome-card-name">
            <h3>Care Providers</h3>
            <img
              className="welcome-card-logo-resized"
              src={require("../images/provider_icon.png")}
              alt="logo"
            />
          </div>

          <div className="welcome-card-body">
            <div className="welcome-card-detail">
              <h4>Click to view</h4>
            </div>
            <div>
              <img
                className="welcome-card-logo"
                src={require("../images/provider_icon.png")}
                alt="logo"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="welcome-grid-bot">
        <div id="invoices-button" className="welcome-card">
          <div className="welcome-card-name">
            <h3>Invoices</h3>
            <img
              className="welcome-card-logo-resized"
              src={require("../images/invoice_icon.png")}
              alt="logo"
            />
          </div>

          <div className="welcome-card-body">
            <div className="welcome-card-detail">
              <h4>$0.00</h4>
              <h4>Current Balance</h4>
            </div>
            <div>
              <img
                className="welcome-card-logo"
                src={require("../images/invoice_icon.png")}
                alt="logo"
              />
            </div>
          </div>
        </div>
        <div id="account-button" className="welcome-card">
          <div className="welcome-card-name">
            <h3>Account</h3>
            <img
              className="welcome-card-logo-resized"
              src={require("../images/house_icon.png")}
              alt="logo"
            />
          </div>
          <div
            className="welcome-card-body"
            onClick={() => navigateToScreen("Account")}
          >
            <h4>Click to view</h4>
            <div className="welcome-card-detail">
              <img
                className="welcome-card-logo"
                src={require("../images/house_icon.png")}
                alt="logo"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserWelcomeScreen;
